import * as CONST from '../ActionTypes';

const initialState = {
  isSuccess: false,
  isFailure: false,
};
function mypage(state = initialState, action) {
  switch (action.type) {
    // -----------------
    // 登録情報変更
    // -----------------
    case CONST.UPDATE_CUSTOMER_SUCCESS:
      return {

        ...state,
        isSuccess: true,
        isFailure: false,
      };
    case CONST.UPDATE_CUSTOMER_FAILURE:
      return {

        ...state,
        isSuccess: false,
        isFailure: true,
      };
    // -----------------
    // お届け先変更
    // -----------------
    case CONST.UPDATE_ADDRESS_SUCCESS:
      return {

        ...state,
        isSuccess: true,
        isFailure: false,
      };
    case CONST.UPDATE_ADDRESS_FAILURE:
      return {

        ...state,
        isSuccess: false,
        isFailure: true,
      };
      // -----------------
    // お届け先追加
    // -----------------
    case CONST.ADD_ADDRESS_SUCCESS:
      return {

        ...state,
        isSuccess: true,
        isFailure: false,
      };
    case CONST.ADD_ADDRESS_FAILURE:
      return {

        ...state,
        isSuccess: false,
        isFailure: true,
      };
    case CONST.CLEAR_MYPAGE_RESULT_FLG:
      return {

        ...state,
        isSuccess: false,
        isFailure: false,
      };
    default:
      return state;
  }
}
export default mypage;
